<template>
    <div class="content p-1 ms-2 me-2 ms-lg-4 me-lg-4">
        <div class="md-layout">
            <div class="row">
                <div class="col-12 col-md-7 col-lg-8 col-xl-8 text-center">
                    <md-field>
                        <label for="plant_select">選擇案場</label>
                        <md-select v-model="plant_select" name="plant_select" id="plant_select">
                            <md-option v-for="(plant_data, pv_plant_ID) in plant_information" v-bind:key="pv_plant_ID" :value="pv_plant_ID">{{plant_data["name"]}}</md-option>
                        </md-select>
                    </md-field>
                </div>
            </div> 
        </div>
        <div v-if="plant_select !== null">
            <div class="md-layout">
                <div class="card col-12">
                    <div class="row g-0">
                        <div class="col-md-4">
                            <img src="../assets/img/plant1.png" class="img-fluid rounded-start" alt="...">
                        </div>
                        <div class="col-md-8">
                            <div class="card-body">
                                <div class="d-flex align-items-center">
                                    <h3 class="card-title">{{plant_information[plant_select]["name"]}}</h3>
                                    <div class="d-flex ms-auto text-success" v-if="plant_information[plant_select]['data']['led_state'] == 0">
                                        <font-awesome-icon class="card-title " :icon="['fas', 'check-circle']" />
                                        <h6 class="card-title">狀態正常</h6>
                                    </div>
                                    <div class="d-flex ms-auto text-danger fs-4" v-else-if="plant_information[plant_select]['data']['led_state'] == 1">
                                        <font-awesome-icon class="card-title" :icon="['fas', 'exclamation-triangle']" />
                                        <h5 class="card-title">一級警報</h5>
                                    </div>
                                    <div class="d-flex ms-auto text-warning fs-4" v-else-if="plant_information[plant_select]['data']['led_state'] == 2">
                                        <font-awesome-icon class="card-title"  :icon="['fas', 'exclamation']" />
                                        <h5 class="card-title">二級警報</h5>
                                    </div>
                                    <div class="d-flex ms-auto text-secondary fs-4" v-else-if="plant_information[plant_select]['data']['led_state'] == 3">
                                        <font-awesome-icon class="card-title" :icon="['fas', 'times']" />
                                        <h5 class="card-title">設備斷線</h5>
                                    </div>
                                    <div class="d-flex ms-auto " v-else>
                                        <h6 class="card-title">取得數據中...</h6>
                                    </div>
                                </div>
                
                                <div class="row ms-1 ">
                                    <div class="col-xxl-3 col-xl-3 col-lg-5 col-md-4 col-sm-3 col-12 ps-0 fs-6 align-items-end ">
                                        <i class="fas fa-database fs-4"></i><i class="fas fa-bolt fs-6"></i>
                                        <span style="font-size: 0.25rem;">&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;</span>
                                        <span>案場容量</span>
                                    </div>
                                    <div class="d-flex col-xxl-3 col-xl-4 col-lg-7 col-md-8 col-sm-9 col-12 fs-6 ps-0 justify-content-center align-items-end">
                                        <label class="fs-5 fw-bold">{{plant_information[plant_select]['capacity']}}</label>
                                        <label class="fs-7">kW</label>
                                    </div>
                                </div>
                                <div class="row ms-1 ">
                                    <div class="col-xxl-3 col-xl-3 col-lg-5 col-md-4 col-sm-3 col-12 ps-0 fs-6 align-items-end ">
                                        <font-awesome-icon class="fs-4" :icon="['fas', 'charging-station']" /><span style="font-size: 0.25rem; color: green;">Day &nbsp; &nbsp;</span>
                                        <span>本日發電量</span>
                                    </div>
                                    <div class="d-flex col-xxl-3 col-xl-4 col-lg-7 col-md-8 col-sm-9 col-12 fs-6 ps-0 justify-content-center align-items-end">
                                        <label class="fs-5 fw-bold">{{plant_information[plant_select]["data"]["kwh_today"]}}</label>
                                        <label class="fs-7">kWh</label>
                                    </div>
                                </div>
                                <div class="row ms-1 ">
                                    <div class="col-xxl-3 col-xl-3 col-lg-5 col-md-4 col-sm-3 col-12 ps-0 fs-6 align-items-end ">
                                        <font-awesome-icon class="fs-4" :icon="['fas', 'charging-station']" /><span style="font-size: 0.25rem; color: orange;">Month</span>
                                        <span>本月發電量</span>
                                    </div>
                                    <div class="d-flex col-xxl-3 col-xl-4 col-lg-7 col-md-8 col-sm-9 col-12 fs-6 ps-0 justify-content-center align-items-end">
                                        <label class="fs-5 fw-bold">{{plant_information[plant_select]["data"]["kwh_month"]}}</label>
                                        <label class="fs-7">kWh</label>
                                    </div>
                                </div>
                                <div class="row ms-1 ">
                                    <div class="col-xxl-3 col-xl-3 col-lg-5 col-md-4 col-sm-3 col-12 ps-0 fs-6 align-items-end ">
                                        <font-awesome-icon class="fs-4" :icon="['fas', 'charging-station']" /><span style="font-size: 0.25rem; color: red;">Year &nbsp;</span>
                                        <span>本年發電量</span>
                                    </div>
                                    <div class="d-flex col-xxl-3 col-xl-4 col-lg-7 col-md-8 col-sm-9 col-12 fs-6 ps-0 justify-content-center align-items-end">
                                        <label class="fs-5 fw-bold">{{plant_information[plant_select]["data"]["kwh_year"]}}</label>
                                        <label class="fs-7">kWh</label>
                                    </div>
                                </div>
                                
                                <!-- <p class="card-text"><small class="text-muted">Last updated 3 mins ago</small></p> -->
                            </div>
                        </div>
                    </div>
                    <div class="row g-0">
                        <button class="btn equip_group_btn col-12 col-lg-3 equip_group_border" @click="equip_group_onClick('ALL')" :class="{active: equip_group_mode == 'ALL'}">案場總錶</button>
                        <button class="btn equip_group_btn col-12 col-lg-3 equip_group_border" @click="equip_group_onClick('INV')" :class="{active: equip_group_mode == 'INV'}" >變流器</button>
                        <button class="btn equip_group_btn col-12 col-lg-3 equip_group_border" @click="equip_group_onClick('STRING')" :class="{active: equip_group_mode == 'STRING'}">串電流表</button>
                        <button class="btn equip_group_btn col-12 col-lg-3" @click="equip_group_onClick('SENSOR')" :class="{active: equip_group_mode == 'SENSOR'}">環境感測器</button>
                    
                    </div>
                </div>

                <div class="card col-12 mt-3 mt-lg-0">
                    <div class="row g-0">
                        <div class="row g-0" v-if="equip_group_mode == 'INV'">
                            <div class="col-lg-3 col-12">
                                <select class="form-select point_btn" v-model="inv_select">
                                    <option v-for="(inv_data, inv_ID) in inverter_information" v-bind:key="inv_ID" :value="inv_ID">{{inv_data["name"]}}</option>
                                </select>
                            </div>
                            <div class="col-lg-9 col-12 ps-2">
                                <h4>{{inverter_information[inv_select]["name"]}}</h4>
                                <div class="alert alert-success d-flex align-items-center p-1 mt-1 mb-2" role="alert" v-if="inverter_information[inv_select]['state'] == 0">
                                    <font-awesome-icon  :icon="['fas', 'check-circle']" />
                                    <label class="fs-6">狀態正常</label>
                                </div>
                                <div class="alert alert-danger d-flex align-items-center p-1 mt-1 mb-2" role="alert" v-else-if="inverter_information[inv_select]['state'] == 1">
                                    <font-awesome-icon :icon="['fas', 'exclamation-triangle']" />
                                    <label class="fs-6">一級警報</label>
                                </div>
                                <div class="alert alert-warning d-flex align-items-center p-1 mt-1 mb-2" role="alert" v-else-if="inverter_information[inv_select]['state'] == 2">
                                    <font-awesome-icon :icon="['fas', 'exclamation']" />
                                    <label class="fs-6">二級警報</label>
                                </div>
                                <div class="alert alert-secondary d-flex align-items-center p-1 mt-1 mb-2" role="alert" v-else-if="inverter_information[inv_select]['state'] == 3">
                                    <font-awesome-icon :icon="['fas', 'times']" />
                                    <label class="fs-6">設備斷線</label>
                                </div>
                                <div class="alert alert-white d-flex align-items-center p-1 mt-1 mb-2" role="alert" v-else>
                                    <label class="fs-6">取得數據中...</label>
                                </div>
                                <label class="fs-6">Inverter型號：{{inverter_information[inv_select]["Device_model"]}}</label>
                                <br/>
                                <label class="fs-6">裝置容量: {{inverter_information[inv_select]["capacity"]}}<span class="fs-7">kW</span></label>
                                
                            </div>
                        </div>

                        <div class="row g-0" v-else-if="equip_group_mode == 'STRING'">
                            <div class="text-center p-2" v-if="Object.keys(string_information).length == 0">
                                <label class="fs-4">無串列電流錶</label>
                            </div>
                            <div class="d-flex" v-else>
                                <div class="col-lg-3 col-12">
                                    <select class="form-select point_btn" v-model="string_select">
                                        <option v-for="(string_data, string_ID) in string_information" v-bind:key="string_ID" :value="string_ID">{{string_data["name"]}}</option>
                                    </select>
                                </div>
                                <div class="col-lg-9 col-12 ps-2">
                                    <h4>{{string_information[string_select]["name"]}}</h4>
                                    <div class="alert alert-success d-flex align-items-center p-1 mt-1 mb-2" role="alert" v-if="string_information[string_select]['state'] == 0">
                                        <font-awesome-icon  :icon="['fas', 'check-circle']" />
                                        <label class="fs-6">狀態正常</label>
                                    </div>
                                    <div class="alert alert-danger d-flex align-items-center p-1 mt-1 mb-2" role="alert" v-else-if="string_information[string_select]['state']== 1">
                                        <font-awesome-icon :icon="['fas', 'exclamation-triangle']" />
                                        <label class="fs-6">一級警報</label>
                                    </div>
                                    <div class="alert alert-warning d-flex align-items-center p-1 mt-1 mb-2" role="alert" v-else-if="string_information[string_select]['state'] == 2">
                                        <font-awesome-icon :icon="['fas', 'exclamation']" />
                                        <label class="fs-6">二級警報</label>
                                    </div>
                                    <div class="alert alert-secondary d-flex align-items-center p-1 mt-1 mb-2" role="alert" v-else-if="string_information[string_select]['state']== 3">
                                        <font-awesome-icon :icon="['fas', 'times']" />
                                        <label class="fs-6">設備斷線</label>
                                    </div>
                                    <div class="alert alert-white d-flex align-items-center p-1 mt-1 mb-2" role="alert" v-else>
                                        <label class="fs-6">取得數據中...</label>
                                    </div>
                                    <label class="fs-6">變流器：{{string_information[string_select]["inv"]}}</label>
                                    <br/>
                                    <label class="fs-6">串列數：{{string_information[string_select]["serial_num"]}}</label>
                                    <br/>
                                    <label class="fs-6">每串模組數：{{string_information[string_select]["module_num"]}}</label>
                                    
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card col-12">
                    <div class="g-0">
                        <div v-if="equip_group_mode === 'ALL'">
                            <plant-total v-bind:pv_plant_ID="plant_select"  :key="plant_select"></plant-total>
                        </div>
                        <div v-if="equip_group_mode == 'INV'">
                            <inverter v-bind:inv_select="inv_select" v-bind:inv_model="inverter_information[inv_select]['Device_model']" :key="inv_select"></inverter>
                        </div>
                        <div v-if="equip_group_mode == 'STRING' && Object.keys(string_information).length > 0">
                            <string v-bind:string_select="string_select"  :key="string_select"></string>
                        </div>
                        <div v-if="equip_group_mode == 'SENSOR'">
                            <sensor v-bind:pv_plant_ID="plant_select"  :key="plant_select"></sensor>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import PlantTotal from "../components/PlantInfo/PlantTotal.vue"
import Inverter from "../components/PlantInfo/Inverter.vue"
import String from "../components/PlantInfo/String.vue"
import Sensor from "../components/PlantInfo/Sensor.vue"
import Plotly from "plotly.js"

export default {
    components: {
        PlantTotal,
        Inverter,
        String,
        Sensor,
    },
    data(){
        return {
            plant_information: {},
            inverter_information: {},
            string_information: {},
            plant_select: null,
            inv_select: null,
            string_select: null,
            equip_group_mode: "ALL",
            equip_point_type: null,
        }
    },
    methods: {
        pv_plant_info(auto_select=null){
            let that = this
            this.axios.get("/pv_plant_information")
            .then(function (data) {
                // 帶入params
                that.plant_information = {}
                for(var i in data.data.information){
                    that.plant_information[data.data.information[i]['_id']] = data.data.information[i]
                    if(auto_select !== null){
                        if(data.data.information[i]['_id']  === auto_select ){
                            that.plant_select = auto_select
                            that.get_plant_data()
                        }
                    }
                }
                //console.log(that.plant_information)
            })
            return false
        },
        get_plant_data(){
            //Get inverter info
            const that = this
            that.inverter_information = {}
            this.axios.get(`/get_inv_information?pv_plant_ID=${this.plant_select}`)
            .then(function (data) {
                // 帶入params
                that.inverter_information = data.data.data
                for(var i in data.data.data){
                    that.inv_select = i
                    break
                }
            })
            //Get string info
            that.string_information = {}
            this.axios.get(`/get_string_information?pv_plant_ID=${this.plant_select}`)
            .then(function (data) {
                // 帶入params
                that.string_information = data.data.data
                for(var i in data.data.data){
                    that.string_select = i
                    break
                }
            })
        },
        equip_group_onClick(group_type){
            this.equip_group_mode = group_type
        },
        equip_point_onChoose(point_type){
            this.equip_point_type = point_type
            const PLOT = document.getElementById('plot_desktop');
            Plotly.newPlot( TESTER, [{
            x: [1, 2, 3, 4, 5],
            y: [1, 2, 4, 8, 16] }], {
            margin: { t: 0 } } );

        },
        sync_with_server(){
            const that = this
            const current_mode = this.equip_group_mode
            this.pv_plant_info()
            if(this.plant_select == null){ //無選擇案場
                return false
            }
            if(current_mode == "ALL"){
                //this.pv_plant_info()

            }else if(current_mode == "INV"){

            }else if(current_mode == "STRING"){

            }else if(current_mode == "SENSOR"){

            }
        },
    },
    mounted(){
        // Doing With Params
        let x = document.querySelector('a[href="/plant_info"]')
        x.classList.add("active")
        this.pv_plant_info(this.$router.history.current.query.ID)
        /* if(this.$router.history.current.query.ID !== null){
            this.plant_select = this.$router.history.current.query.ID            
        } */
        this.syncdata = setInterval(this.sync_with_server, 5000)
    },
    watch:{
        plant_select: function(){
            this.get_plant_data()
        }
    },
    destroyed(){
        clearInterval(this.syncdata)
    },
};
</script>
<style src="../assets/css/PlantInfo.css"></style>